import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-45d68f8f"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  viewBox: "0 0 128 128",
  "class": "icon-spin tw-w-6 tw-h-6"
};
var _hoisted_2 = ["stroke-width"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    "class": _normalizeClass(["tw-flex tw-justify-center tw-items-center tw-m-auto", $props.color])
  }, [(_openBlock(), _createElementBlock("svg", _hoisted_1, [_createElementVNode("circle", {
    "class": "path",
    cx: "64",
    cy: "64",
    r: "42",
    fill: "none",
    "stroke-width": $props.thickness
  }, null, 8 /* PROPS */, _hoisted_2)]))], 2 /* CLASS */);
}